import { useEffect, useState } from "react";

function useDebounce(callback, operationType) {
	const [debouncing, setDebouncing] = useState(false);

	const delayLookup = {
		dataFiltering: 1000,
		default: 1000,
		infiniteScroll: 500,
	};

	useEffect(() => {
		if (debouncing) {
			const timeoutId = setTimeout(() => {
				callback();
				setDebouncing(false);
			}, delayLookup[operationType] || delayLookup.default);

			return () => clearTimeout(timeoutId);
		}
	}, [debouncing, callback, operationType]);

	return () => setDebouncing(true);
}

export default useDebounce;
